import axios from "axios";
import { API } from "../App";

const CHUNK = 4 * 1024 * 1024;

// Chunked upload of a video file → page_media doc on {kind, slug}. Resolves with the created doc.
export async function uploadVideoChunks(kind, slug, file, onProgress) {
  const n = Math.ceil(file.size / CHUNK), id = `${Date.now()}${Math.random().toString(36).slice(2, 6)}`;
  let last = null;
  for (let i = 0; i < n; i++) {
    const fd = new FormData();
    fd.append("kind", kind); fd.append("slug", slug); fd.append("title", file.name.replace(/\.[^.]+$/, "")); fd.append("upload_id", id);
    fd.append("chunk_index", i); fd.append("total_chunks", n); fd.append("filename", file.name); fd.append("file", file.slice(i * CHUNK, (i + 1) * CHUNK), `p${i}`);
    last = (await axios.post(`${API}/admin/page-media/video-chunk`, fd, { withCredentials: true })).data;
    onProgress?.(Math.round(((i + 1) / n) * 100));
  }
  return last;
}

// Turn a THE WALL page path/URL into the {kind, slug} a video attaches to.
export function pageTarget(input) {
  let p = (input || "").trim();
  try { if (p.startsWith("http")) p = new URL(p).pathname; } catch { /* keep raw */ }
  p = p.replace(/\/+$/, "");
  if (p === "/about") return { kind: "page", slug: "about" };
  const m = p.match(/^\/(artists|bands|artist\/page|organizations|org|business\/page|business)\/([^/?#]+)/);
  if (!m) return null;
  const kind = /^(artists|bands|artist\/page)$/.test(m[1]) ? "artist" : /^(organizations|org)$/.test(m[1]) ? "org" : "business";
  return { kind, slug: decodeURIComponent(m[2]) };
}

export function pagePath(kind, slug) {
  if (kind === "page") return `/${slug}`;
  if (kind === "artist") return `/artists/${slug}`;
  if (kind === "org") return `/organizations/${slug}`;
  if (kind === "business") return `/business/${slug}`;
  return null;
}
